<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M19.627 18.213a8.667 8.667 0 10-1.414 1.414l8.052 8.053a1 1 0 001.415-1.415l-8.053-8.052zm-9.794-6.38a1 1 0 100 2h6a1 1 0 100-2h-6z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsZoomOutFilled'
}
</script>
